import { AccountType, Address, GenericObject, PaymentMethod, Tag, copyFields } from '@synergy/models';

import { Contact } from './contact';

export class Account {
    public id!: number;
    public name!: string;
    public categoryIds!: number[];
    public isContractPartner!: boolean;
    public type!: AccountType;
    public addresses?: Address[];
    public contacts?: Contact[];
    public mainAddress?: Address;
    public mainContact?: Contact;
    public termsOfDelivery!: string;
    public termsOfPayment!: string;
    public tags?: Tag[];
    public paymentMethod!: PaymentMethod;
    public ftpUsername?: string;
    public glnNumber?: string;
    public email?: string;
    public phone?: string;
    public image?: string;
    public isMain!: boolean;
    public taxRateId?: number;
    public paymentTermId?: number;
    public paymentTermPoolId?: number;
    public isLocked?: boolean;

    public static fromPlainObject(object: GenericObject): Account {
        const account = new Account();

        copyFields(object, account);

        if (object['addresses']) {
            account.addresses = object['addresses'].map(Address.fromPlainObject);
        }

        if (object['contacts']) {
            account.contacts = object['contacts'].map(Contact.fromPlainObject);
        }

        return account;
    }

    public getDisplayString() {
        const city = this.getCity();
        return city ? `${this.name}, ${city}` : this.name;
    }

    public getMainContact(): Contact | undefined {
        return this.mainContact || this.contacts?.[0];
    }

    public getCity(): string | undefined {
        const mainAddress =
            this.mainAddress || this.addresses?.find(address => address.isMainAddress) || this.addresses?.[0];
        return mainAddress?.city;
    }

    public getTags(maxLength?: number) {
        let tags = (this.tags && this.tags.map(tag => tag.name).join(' ')) || '';
        if (maxLength && tags.length > maxLength) {
            tags = tags.substring(0, maxLength) + '...';
        }
        return tags;
    }
}
